import { motion } from "framer-motion";

/**
 * Line-by-line masked reveal for headings.
 * Splits the text on \n or explicit array; each line is masked (translateY 110%) then springs in.
 */
export default function MaskedLines({
  text,
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.14,
  duration = 1.0,
}) {
  const lines = Array.isArray(text) ? text : String(text || "").split("\n");
  return (
    <span className={`block ${className}`}>
      {lines.map((line, i) => (
        <span
          key={i}
          className={`block overflow-hidden ${lineClassName}`}
          style={{ paddingBottom: "0.08em" }}
        >
          <motion.span
            className="block will-change-transform"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration,
              delay: delay + i * stagger,
              ease: [0.16, 1, 0.3, 1],
            }}
          >
            {line || "\u00A0"}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
